<div class="ir-item-line th-filter" *ngIf="points?.length">
  <div class="ir-item-cell s8 clickable" (click)="setOrderBy('name')">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'common.name' | translate }}
    </span>
  </div>
  <div class="ir-item-cell s2 clickable right" (click)="setOrderBy('status')">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>

      {{ 'common.status' | translate }}
    </span>
  </div>
</div>

<div class="ir-item-empty ir-mv8" *ngIf="allItems?.length == 0">
  <p>
    <span>{{ 'points.no-points' | translate }}</span>
  </p>
</div>
<div class="ir-content-flow" *ngIf="allItems?.length > 0" [ngClass]="allItems?.length > 0 ? 'has-filter' : ''">
  <div *ngFor="let item of allItems | orderBy : orderByFieldName : direction | searchBy : query">
    <div
      *ngIf="item.type === 100"
      class="ir-item-line th-point clickable"
      [ngClass]="{ done: item.status === 100, indent: selectable }"
      (click)="openFolder(item)"
    >
      <div class="ir-item-cell s8">
        <div class="ir-item-selector" *ngIf="selectable" (click)="selectFolder($event, item)">
          <i class="material-icons" *ngIf="!item.selected">check_box_outline_blank</i>
          <i class="material-icons" *ngIf="item.selected">check_box</i>
        </div>
        <span class="icon-label"> <i class="material-icons">folder</i>{{ allItemsOrdersById[item.id] }} {{ item.name }}</span>
      </div>
      <div class="ir-item-cell s2 right strong statut">
        <ng-container *ngFor="let session of item.sessions">
          <i
            *ngIf="session.user"
            class="material-icons"
            [title]="session.user"
            [style.color]="session.color"
            [class.disabled]="session.away"
            [class.away]="session.away"
            [class.active]="!session.away"
            >account_circle</i
          >
        </ng-container>
        <i *ngFor="let icon of item.icons | orderBy : 'order'" class="material-icons {{ icon.classes }}">{{
          icon.count !== 0 ? icon.name : ''
        }}</i>
        <span>{{ item?.getProgression() }} %</span>
      </div>
    </div>
    <div
      *ngIf="item.type === 200"
      class="ir-item-line th-point clickable"
      [ngClass]="{ done: item.status === 100, indent: selectable }"
      (click)="openPoint(item)"
    >
      <div class="ir-item-cell s8">
        <div class="ir-item-selector" *ngIf="selectable" (click)="selectPoint($event, item)">
          <i class="material-icons" *ngIf="!item.selected">check_box_outline_blank</i>
          <i class="material-icons" *ngIf="item.selected">check_box</i>
        </div>
        <span>{{ allItemsOrdersById[item.id] }} {{ item.name }}</span>
      </div>
      <div class="ir-item-cell s2 right strong statut">
        <ng-container *ngFor="let session of item.sessions">
          <i
            *ngIf="session.user"
            class="material-icons"
            [title]="session.user"
            [style.color]="session.color"
            [class.disabled]="session.away"
            [class.away]="session.away"
            [class.active]="!session.away"
            >account_circle</i
          >
        </ng-container>
        <i *ngFor="let icon of item.icons | orderBy : 'order'" class="material-icons {{ icon.classes }}">{{ icon.name }}</i>
        <i class="material-icons" *ngIf="item.isDraft()">remove</i>
        <i class="material-icons" *ngIf="item.isDone()">check</i>
        <i class="material-icons" *ngIf="item.isNotApplicable()">not_interested</i>
      </div>
    </div>
  </div>
</div>
